import request from '@/utils/request'

/**
 *  获取我的任务列表
 * @param param
 * @returns {*}
 */
export function getMyTaskListAPI(param) {
    return request({
        url: '/project/task/selectMyTaskList',
        headers: {
            isToken: true,
        },
        method: 'get',
        params: param
    })
}



/**
 *  反馈提交
 * @param data
 * @returns {*}
 */
export function saveFeedbackAPI(data) {
    return request({
        url: '/project/task/feedback',
        headers: {
            isToken: true,
        },
        method: 'post',
        data: data
    })
}

/**
 *  删除反馈
 * @param id
 * @returns {*}
 */
export function deltelFeedback(id) {
    return request({
        url: '/project/task/feedback/' + id,
        headers: {
            isToken: true,
        },
        method: 'delete',
    })
}

/**
 *  反馈列表
 * @param params
 * @returns {*}
 */
export function getFeedbackListAPI(params) {
    return request({
        url: '/project/task/feedback/list',
        headers: {
            isToken: true,
        },
        method: 'get',
        params: params
    })
}

/**
 *  根据任务id获取任务详情
 * @param id
 * @returns {*}
 */
export function getTaskDetailsAPI(id) {
    return request({
        url: '/project/task/' + id,
        headers: {
            isToken: true,
        },
        method: 'get',
    })
}

/**
 *  查询评论列表
 * @param params
 * @returns {*}
 */
export function getCommentListAPI(params) {
    return request({
        url: '/task/taskComment/list',
        headers: {
            isToken: true,
        },
        method: 'get',
        params: params
    })
}

/**
 * 评论提交
 * @param data
 * @returns {*}
 */
export function saveCommentAPI(data) {
    return request({
        url: '/task/taskComment',
        headers: {
            isToken: true,
        },
        method: 'post',
        data: data
    })
}

// 限制反馈时长
export function getFeedbackHours(query) {
    return request({
        url: '/project/task/feedback/getFeedbackHours',
        method: 'get',
        params: query
    })
}
